import toast from "react-hot-toast";
import ChannelManagerList from "../../pages/ChanelPage";

const confirmToast = (brand, channelProgramme, handleUpdateBrand) => {
    toast((t) => (
        <div className="relative p-6 bg-gradient-to-br from-red-50 to-red-100 border border-red-200 rounded-xl shadow-2xl max-w-md mx-auto backdrop-blur-sm">
            {/* Decorative elements */}
            <div className="absolute top-0 right-0 w-20 h-20 bg-red-500 opacity-10 rounded-full -translate-y-2 translate-x-2"></div>
            <div className="absolute bottom-0 left-0 w-16 h-16 bg-red-600 opacity-5 rounded-full translate-y-2 -translate-x-2"></div>

            {/* Icon */}
            <div className="flex items-center justify-center w-12 h-12 bg-red-100 rounded-full mx-auto mb-4">
                <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                </svg>
            </div>

            {/* Content */}
            <div className="text-center mb-6">
                <h3 className="text-lg font-bold text-gray-800 mb-2">
                    Confirm Update
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                    Are you sure you want to update this brand and channel programme?
                </p>
            </div>

            {/* Action buttons */}
            <div className="flex gap-3 justify-center">
                <button
                    className="px-6 py-2.5 bg-white text-gray-700 font-medium rounded-lg border border-gray-300 hover:bg-gray-50 hover:border-gray-400 transition-all duration-200 shadow-sm hover:shadow-md transform hover:scale-105 active:scale-95"
                    onClick={() => toast.dismiss(t.id)}
                >
                    Cancel
                </button>
                <button
                    className="px-6 py-2.5 bg-gradient-to-r from-red-500 to-red-600 text-white font-medium rounded-lg hover:from-red-600 hover:to-red-700 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105 active:scale-95 focus:ring-4 focus:ring-red-200"
                    onClick={() => {
                        handleUpdateBrand(brand, channelProgramme);
                        toast.dismiss(t.id);
                    }}
                >
                    Yes, Update
                </button>
            </div>
        </div>
    ), {
        duration: Infinity,
        position: "top-center",
        style: {
            background: 'transparent',
            boxShadow: 'none',
            padding: 0,
        }
    });
};

export default confirmToast
